import React, { useContext, useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import './Doc.css';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as STORAGE_BUCKET from '../../constants/storageBucket';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import HelloSign from 'hellosign-embedded';
import CheckIcon from '@material-ui/icons/Check';
import './StepBar.css';
import { constant, forEach } from 'lodash';
import { Box, LinearProgress, Paper } from '@material-ui/core';
import dayjs from 'dayjs';
import Modal from '../layout/modal/Modal';
import { useLocation } from 'react-router';
import { SaveOrUpdateDocument } from './SaveAndLoadDocument';

function StepBar({
	lotList,
	setElevationList,
	elevationList,
	setPricingDetails,
	setElevationPriceSum,
	exteriorImage,
	setExteriorImage,
	navigation,
	buildingPriceSum,
	setBuildingPriceSum,
	elevationPriceSum,
	lotPriceSum,
	setLotPriceSum,
	elevationPrice,
	elevationId,
	lotPrice,
	pricingDetails,
	totalUpgradePrice,
	upgradeTotal,
	irrevocableDate,
	closingDate,
	individualDetails,
	corporationDetails,
	lawyerDetails,
	mortgageDetails,
	expanded,
	setExpanded,
	setIsCompleted,
	isCompleted,
	setDisable,
	disable,
	loading,
	setLoading,
	upgradeTotalPrice,
	displayFinal,
	setDisplayFinal,
	setElevationId,
	floorplan,
	totalMainFloor,
	setElevationTab,
	elevationTab,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [active, setActive] = useState();
	const [allInfoCombined] = useState({});
	const [show, setShow] = useState(false);
	const converter = require('number-to-words');

	const totalUpgrades =
		upgradeTotalPrice.cabinetry +
		upgradeTotalPrice.countertops +
		upgradeTotalPrice.doorstrim +
		upgradeTotalPrice.flooring +
		upgradeTotalPrice.lighting +
		upgradeTotalPrice.plumbing;

	const client = new HelloSign();

	const handleDocument = () => {
		setShow(false);
		setLoading(true);
		const getDoc = firebase
			.functions()
			.httpsCallable('helloSignDocumentCreate');
		var currentUserId = firebase.auth().currentUser.uid;
		var currentUserName = firebase.auth().currentUser.displayName;
		var currentUserPhone = firebase.auth().currentUser.phoneNumber;
		var buildingCost = elevationList[0]?.buildingPrice;
		var totalCost =
			elevationList[0]?.buildingPrice +
			elevationPrice +
			lotPrice +
			upgradeTotal;
		var clientEmail = location.state.clientEmail;

		console.log('Client Email: ' + clientEmail);

		console.log('SELLER: ' + JSON.stringify(firebase.auth().currentUser));

		var num =
			'zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen'.split(
				' '
			);
		var tens = 'twenty thirty forty fifty sixty seventy eighty ninety'.split(
			' '
		);

		function number2words(n) {
			if (n < 20) return num[n];
			var digit = n % 10;
			if (n < 100)
				return tens[~~(n / 10) - 2] + (digit ? '-' + num[digit] : '');
			if (n < 1000)
				return (
					num[~~(n / 100)] +
					' hundred' +
					(n % 100 == 0 ? '' : ' ' + number2words(n % 100))
				);
			return (
				number2words(~~(n / 1000)) +
				' thousand' +
				(n % 1000 != 0 ? ' ' + number2words(n % 1000) : '')
			);
		}
		console.log(
			'info needed: mortgageDetails - ' + JSON.stringify(mortgageDetails)
		);
		console.log(
			'info needed: lawyerDetails - ' + JSON.stringify(lawyerDetails)
		);
		console.log(
			'info needed: individualDetails - ' + JSON.stringify(pricingDetails)
		);
		console.log(
			'info needed: corporationDetails - ' + JSON.stringify(corporationDetails)
		);
		console.log(
			'info needed: irrevocable - ' + JSON.stringify(irrevocableDate)
		);
		console.log('info needed: closing - ' + JSON.stringify(closingDate));
		console.log('info needed: Totalcost - ' + JSON.stringify(upgradeTotal));
		console.log('info needed: elevation id - ' + JSON.stringify(elevationId));
		console.log('info needed: user id- ' + currentUserId);

		allInfoCombined['clientEmail'] = clientEmail;
		allInfoCombined['buyerFirstName'] = individualDetails?.firstName;
		allInfoCombined['buyerLastName'] = individualDetails?.lastName;
		allInfoCombined['buildingLotNumber'] = pricingDetails[0]?.id;
		allInfoCombined['buildingModelName'] = elevationList[0]?.buildingName;
		allInfoCombined['buildingPrice'] = buildingCost;
		allInfoCombined['buildingPriceWord'] = converter.toWords(buildingCost);
		allInfoCombined['irrevocableDay'] =
			dayjs(irrevocableDate).format('DD MMM YYYY');
		allInfoCombined['closingDay'] = dayjs(closingDate).format('DD MMM YYYY');
		allInfoCombined['lawyerName'] = lawyerDetails?.lawyerName;
		allInfoCombined['lawyerAddress'] = lawyerDetails?.address;
		allInfoCombined['lawyerEmail'] = lawyerDetails?.email;
		allInfoCombined['lawyerPhoneNumber'] = lawyerDetails?.phoneNumber;
		allInfoCombined['sellerFullName'] = currentUserName;
		allInfoCombined['sellerPhoneNumber'] = currentUserPhone;
		allInfoCombined['totalCost'] =
			elevationPrice +
			lotPrice +
			totalMainFloor +
			upgradeTotalPrice.cabinetry +
			upgradeTotalPrice.countertops +
			upgradeTotalPrice.doorstrim +
			upgradeTotalPrice.flooring +
			upgradeTotalPrice.lighting +
			upgradeTotalPrice.plumbing;

		console.log(
			'MODEL HOMES - ' +
				JSON.stringify(elevationList[0]) +
				' ELEVATION DETAIL: ' +
				JSON.stringify(pricingDetails[0])
		);
		console.log('Total PRICE: ');
		console.log('CLIENT DETAILS: ' + JSON.stringify(individualDetails));
		console.log('LAW YER DETAILS: ' + JSON.stringify(lawyerDetails));
		console.log('FINANCES DETAILS: ' + mortgageDetails);

		console.log('ALL INFO COMBINED: ' + JSON.stringify(allInfoCombined));

		const displayHelloDoc = (signUrl) => {
			console.log('signurl: ' + signUrl);
			client.open(signUrl, {
				skipDomainVerification: true,
				clientId: 'beab0930839f98ade6e9af78da0ed230',
			});
		};

		getDoc(allInfoCombined)
			.then((result) => {
				setLoading(false);
				console.log('doc result: ' + JSON.stringify(result['data']));
				displayHelloDoc(result['data']);
			})
			.catch(function (error) {
				console.log('Error ' + error);
			});
	};

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
		navigation.go(panel);
	};

	const Accordion = withStyles({
		root: {
			// border: '1px solid rgba(0, 0, 0, .125)',
			marginBottom: '10px',
			boxShadow: 'none',
			'&:not(:last-child)': {
				borderBottom: 0,
			},
			'&:before': {
				display: 'none',
			},
			'&$expanded': {
				margin: 'auto',
				pointerEvent: 'none',
			},
		},
	})(MuiAccordion);

	const AccordionSummary = withStyles({
		root: {
			// backgroundColor: 'rgba(0, 0, 0, .03)',
			backgroundColor: 'transparent',
			// borderBottom: '1px solid rgba(0, 0, 0, .125)',
			marginBottom: -1,
			minHeight: 56,
			color: '#555555',
			fontSize: 18,
			'&$expanded': {
				minHeight: 56,
				color: '#2662F0',
			},
			'&disabled': {
				opacity: '1',
			},
			position: 'relative',
		},
		content: {
			'&$expanded': {
				margin: '12px 0',
			},
		},
		expanded: {},
	})(MuiAccordionSummary);

	const useStyles = makeStyles({
		cardTitle: {
			fontSize: '18px',
			fontWeight: 'bold',
			'&$expanded': {
				color: 'blue',
			},
		},

		caret: {
			marginBottom: '-4px',
		},
	});

	const styles = useStyles();

	const location = useLocation();

	const AccordionDetails = withStyles((theme) => ({
		root: {
			padding: theme.spacing(2),
			display: 'flex',
			flexDirection: 'column',
		},
	}))(MuiAccordionDetails);

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	const elevationHandler = (e) => {
		var lotName = e.currentTarget.dataset.lotname;
		var lotNameToLower = lotName;
		var buildingArr = [];
		var buildingDetails;
		var lotSelected = e.currentTarget.dataset.lotnumber;
		setDisable({ ...disable, lots: false });

		console.log('lotNameToLower: ' + lotNameToLower);

		console.log('lotSelected: ' + lotSelected);

		setActive(lotName);

		firebase.auth().onAuthStateChanged(function (user) {
			function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}

			if (user) {
				firebase
					.database()
					.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/buildingInfo/')
					.orderByKey()
					.equalTo(lotNameToLower)
					.once('value', (snapshot) => {
						console.log('test2 : ' + snapshot);
						var priceBreakdownArr = [];
						var elevationPriceList = [];
						snapshot.forEach((elevationDetail) => {
							console.log('foreach : ' + JSON.stringify(elevationDetail));
							var priceRef = elevationDetail.child('priceList');
							var buildingName = elevationDetail.key;
							var buildingPrice = elevationDetail.val().buildingPrice;
							var buildingSqft = elevationDetail.val().sqft;

							priceRef.forEach((priceDetail) => {
								var priceBreakdown = {
									buildingName: buildingName,
									buildingPrice: buildingPrice,
									elevationId: priceDetail.val().id,
									elevationPrice: priceDetail.val().price,
									sqft: buildingSqft,
								};

								elevationPriceList.push(priceBreakdown.elevationPrice);

								priceBreakdownArr.push(priceBreakdown);

								console.log(
									'preiceBreakdown: ' + JSON.stringify(priceBreakdownArr)
								);
							});
						});

						var sum = elevationPriceList.reduce(function (a, b) {
							return a + b;
						}, 0);

						setElevationPriceSum(sum);

						console.log('elevationList: ' + priceBreakdownArr);

						// RESULT
						// 0: {buildingName: "nova", elevationId: "a", elevationPrice: 0}
						// 1: {buildingName: "nova", elevationId: "b", elevationPrice: 450000}
						// 2: {buildingName: "nova", elevationId: "c", elevationPrice: 500000}
						setElevationList(priceBreakdownArr);
					});

				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected +
							'/buildings/'
					)
					.once('value', (snapshot) => {
						console.log(snapshot.val());
						snapshot.forEach((snap) => {
							// console.log(snap.val()); //building name

							function numberWithCommas(x) {
								return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
							}

							snap.forEach((building) => {
								buildingDetails = {
									id: lotSelected,
									name: capitalizeFirstLetter(building.key),
									price: building.val().priceList,
									sqft: building.val().sqft,
									buildingPrice: numberWithCommas(building.val().buildingPrice),
								};

								buildingArr.push(buildingDetails);
							});
						});
						console.log('buildingArr ' + JSON.stringify(buildingArr));
						setPricingDetails(buildingArr);
					});
			}
		});
	};

	const handleNext = () => {
		setExpanded(expanded + 1);
		navigation.next();
		console.log('NEXT IS PRESSED');
	};
	const handleBack = () => {
		setExpanded(expanded - 1);
		navigation.previous();
	};

	const handleLotsNext = () => {
		if (elevationId === undefined) {
			setElevationId('A');
		}
		if (isCompleted.lots === true) {
			setDisplayFinal({ ...displayFinal, lots: true });

			var documentRef = firebase
				.database()
				.ref(
					'client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						location.state.clientAppCode +
						'/users'
				);

			const isCompletedData = isCompleted;
			const disableData = disable;
			const expandedData = expanded;
			const lotListData = lotList ? lotList : '';
			const elevationListData = elevationList ? elevationList : '';
			const pricingDetailsData = pricingDetails ? pricingDetails : '';
			const displayFinalData = displayFinal ? displayFinal : '';
			const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
			const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
			const exteriorImageData = exteriorImage ? exteriorImage : '';
			const elevationTabData = elevationTab ? elevationTab : '';
			const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
			const elevationPriceData = elevationPrice ? elevationPrice : '';
			const elevationIdData = elevationId ? elevationId : '';
			const lotPriceData = lotPrice ? lotPrice : '';
			const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
			const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
			const closingDateData = closingDate ? closingDate : '';
			const individualDetailsData = individualDetails ? individualDetails : '';
			const corporationDetailsData = corporationDetails
				? corporationDetails
				: '';
			const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
			const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

			if (elevationListData === '') {
				console.log('empty ' + lotListData);
			} else {
				console.log('not empty ');
			}

			var documentJson = {
				isCompleted: isCompletedData,
				disable: disableData,
				expanded: expandedData,
				lotList: lotListData,
				elevationList: elevationListData,
				pricingDetails: pricingDetailsData,
				displayFinal: displayFinalData,
				elevationPriceSum: elevationPriceSumData,
				exteriorImage: exteriorImageData,
				buildingPriceSum: buildingPriceSumData,
				elevationTab: elevationTabData,
				lotPriceSum: lotPriceSumData,
				elevationPrice: elevationPriceData,
				elevationId: elevationIdData,
				lotPrice: lotPriceData,
				totalUpgradePrice: totalUpgradePriceData,
				irrevocableDate: irrevocableDateData,
				closingDate: closingDateData,
				individualDetails: individualDetailsData,
				corporationDetails: corporationDetailsData,
				lawyerDetails: lawyerDetailsData,
				mortgageDetails: mortgageDetailsData,
			};

			SaveOrUpdateDocument(firebase, documentJson);
		}
	};
	const handleModelHomesNext = () => {
		if (elevationId === undefined) {
			setElevationId('A');
		}
		if (isCompleted.modelhomes === true) {
			setDisplayFinal({ ...displayFinal, modelhomes: true });

			var documentRef = firebase
				.database()
				.ref(
					'client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						location.state.clientAppCode +
						'/users'
				);

			const isCompletedData = isCompleted;
			const disableData = disable;
			const expandedData = expanded;
			const lotListData = lotList ? lotList : '';
			const elevationListData = elevationList ? elevationList : '';
			const pricingDetailsData = pricingDetails ? pricingDetails : '';
			const totalMainFloorData = totalMainFloor ? totalMainFloor : '';
			const elevationTabData =
				elevationTab === '' || elevationTab === undefined ? '' : elevationTab;
			const exteriorImageData = exteriorImage ? exteriorImage : '';
			const displayFinalData = displayFinal ? displayFinal : '';
			const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
			const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
			const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
			const elevationPriceData = elevationPrice ? elevationPrice : '';
			const elevationIdData = elevationId ? elevationId : '';
			const lotPriceData = lotPrice ? lotPrice : '';
			const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
			const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
			const closingDateData = closingDate ? closingDate : '';
			const individualDetailsData = individualDetails ? individualDetails : '';
			const corporationDetailsData = corporationDetails
				? corporationDetails
				: '';
			const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
			const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

			if (elevationListData === '') {
				console.log('empty ' + lotListData);
			} else {
				console.log('not empty ');
			}

			console.log('Elevation Tab Data : ' + elevationTabData);

			var documentJson = {
				isCompleted: isCompletedData,
				disable: disableData,
				expanded: expandedData,
				lotList: lotListData,
				elevationList: elevationListData,
				pricingDetails: pricingDetailsData,
				displayFinal: displayFinalData,
				elevationTab: elevationTabData,
				exteriorImage: exteriorImageData,
				totalMainFloor: totalMainFloorData,
				elevationPriceSum: elevationPriceSumData,
				buildingPriceSum: buildingPriceSumData,
				lotPriceSum: lotPriceSumData,
				elevationPrice: elevationPriceData,
				elevationId: elevationIdData,
				lotPrice: lotPriceData,
				totalUpgradePrice: totalUpgradePriceData,
				irrevocableDate: irrevocableDateData,
				closingDate: closingDateData,
				individualDetails: individualDetailsData,
				corporationDetails: corporationDetailsData,
				lawyerDetails: lawyerDetailsData,
				mortgageDetails: mortgageDetailsData,
			};

			SaveOrUpdateDocument(firebase, documentJson);
		}
	};
	const handlePricingNext = () => {
		setExpanded(expanded + 1);
		console.log('Clicked');
		setIsCompleted({ ...isCompleted, pricing: true });
		setDisable({ ...disable, pricing: false });

		var documentRef = firebase
			.database()
			.ref(
				'client_appointments/' +
					PROJECT_CODE.projectCode +
					'/' +
					location.state.clientAppCode +
					'/users'
			);

		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
		const exteriorImageData = exteriorImage ? exteriorImage : '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const elevationTabData = elevationTab ? elevationTab : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : '';
		const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
		const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails ? individualDetails : '';
		const corporationDetailsData = corporationDetails ? corporationDetails : '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

		if (elevationListData === '') {
			console.log('empty ' + lotListData);
		} else {
			console.log('not empty ');
		}

		var documentJson = {
			isCompleted: isCompletedData,
			disable: disableData,
			expanded: expandedData,
			lotList: lotListData,
			elevationList: elevationListData,
			pricingDetails: pricingDetailsData,
			displayFinal: displayFinalData,
			elevationPriceSum: elevationPriceSumData,
			elevationTab: elevationTabData,
			exteriorImage: exteriorImageData,
			buildingPriceSum: buildingPriceSumData,
			lotPriceSum: lotPriceSumData,
			elevationPrice: elevationPriceData,
			elevationId: elevationIdData,
			lotPrice: lotPriceData,
			totalUpgradePrice: totalUpgradePriceData,
			irrevocableDate: irrevocableDateData,
			closingDate: closingDateData,
			individualDetails: individualDetailsData,
			corporationDetails: corporationDetailsData,
			lawyerDetails: lawyerDetailsData,
			mortgageDetails: mortgageDetailsData,
		};

		SaveOrUpdateDocument(firebase, documentJson);
	};

	const handleDatesNext = () => {
		setIsCompleted({ ...isCompleted, dates: true });

		var documentRef = firebase
			.database()
			.ref(
				'client_appointments/' +
					PROJECT_CODE.projectCode +
					'/' +
					location.state.clientAppCode +
					'/users'
			);

		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
		const exteriorImageData = exteriorImage ? exteriorImage : '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const elevationTabData = elevationTab ? elevationTab : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : '';
		const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
		const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails ? individualDetails : '';
		const corporationDetailsData = corporationDetails ? corporationDetails : '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

		if (elevationListData === '') {
			console.log('empty ' + lotListData);
		} else {
			console.log('not empty ');
		}

		var documentJson = {
			isCompleted: isCompletedData,
			disable: disableData,
			expanded: expandedData,
			lotList: lotListData,
			elevationList: elevationListData,
			pricingDetails: pricingDetailsData,
			displayFinal: displayFinalData,
			elevationPriceSum: elevationPriceSumData,
			buildingPriceSum: buildingPriceSumData,
			elevationTab: elevationTabData,
			exteriorImage: exteriorImageData,
			lotPriceSum: lotPriceSumData,
			elevationPrice: elevationPriceData,
			elevationId: elevationIdData,
			lotPrice: lotPriceData,
			totalUpgradePrice: totalUpgradePriceData,
			irrevocableDate: irrevocableDateData,
			closingDate: closingDateData,
			individualDetails: individualDetailsData,
			corporationDetails: corporationDetailsData,
			lawyerDetails: lawyerDetailsData,
			mortgageDetails: mortgageDetailsData,
		};

		SaveOrUpdateDocument(firebase, documentJson);
	};

	const handleClientNext = () => {
		setIsCompleted({ ...isCompleted, client: true });
		setDisable({ ...disable, client: false });

		var documentRef = firebase
			.database()
			.ref(
				'client_appointments/' +
					PROJECT_CODE.projectCode +
					'/' +
					location.state.clientAppCode +
					'/users'
			);

		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
		const exteriorImageData = exteriorImage ? exteriorImage : '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const elevationTabData = elevationTab ? elevationTab : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : '';
		const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
		const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails ? individualDetails : '';
		const corporationDetailsData = corporationDetails ? corporationDetails : '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

		if (elevationListData === '') {
			console.log('empty ' + lotListData);
		} else {
			console.log('not empty ');
		}

		var documentJson = {
			isCompleted: isCompletedData,
			disable: disableData,
			expanded: expandedData,
			lotList: lotListData,
			elevationList: elevationListData,
			pricingDetails: pricingDetailsData,
			displayFinal: displayFinalData,
			elevationPriceSum: elevationPriceSumData,
			exteriorImage: exteriorImageData,
			buildingPriceSum: buildingPriceSumData,
			elevationTab: elevationTabData,
			lotPriceSum: lotPriceSumData,
			elevationPrice: elevationPriceData,
			elevationId: elevationIdData,
			lotPrice: lotPriceData,
			totalUpgradePrice: totalUpgradePriceData,
			irrevocableDate: irrevocableDateData,
			closingDate: closingDateData,
			individualDetails: individualDetailsData,
			corporationDetails: corporationDetailsData,
			lawyerDetails: lawyerDetailsData,
			mortgageDetails: mortgageDetailsData,
		};

		SaveOrUpdateDocument(firebase, documentJson);
	};
	const handleLawyerNext = () => {
		setIsCompleted({ ...isCompleted, lawyer: true });
		setDisable({ ...disable, lawyer: false });

		var documentRef = firebase
			.database()
			.ref(
				'client_appointments/' +
					PROJECT_CODE.projectCode +
					'/' +
					location.state.clientAppCode +
					'/users'
			);

		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
		const elevationTabData = elevationTab ? elevationTab : '';
		const exteriorImageData = exteriorImage ? exteriorImage : '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : '';
		const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
		const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails ? individualDetails : '';
		const corporationDetailsData = corporationDetails ? corporationDetails : '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

		if (elevationListData === '') {
			console.log('empty ' + lotListData);
		} else {
			console.log('not empty ');
		}

		var documentJson = {
			isCompleted: isCompletedData,
			disable: disableData,
			expanded: expandedData,
			lotList: lotListData,
			elevationList: elevationListData,
			pricingDetails: pricingDetailsData,
			displayFinal: displayFinalData,
			elevationPriceSum: elevationPriceSumData,
			exteriorImage: exteriorImageData,
			buildingPriceSum: buildingPriceSumData,
			lotPriceSum: lotPriceSumData,
			elevationPrice: elevationPriceData,
			elevationId: elevationIdData,
			lotPrice: lotPriceData,
			totalUpgradePrice: totalUpgradePriceData,
			irrevocableDate: irrevocableDateData,
			elevationTab: elevationTabData,
			closingDate: closingDateData,
			individualDetails: individualDetailsData,
			corporationDetails: corporationDetailsData,
			lawyerDetails: lawyerDetailsData,
			mortgageDetails: mortgageDetailsData,
		};

		SaveOrUpdateDocument(firebase, documentJson);
	};

	const handleFinanceBtn = () => {
		setDisable({ ...disable, finances: false });

		var documentRef = firebase
			.database()
			.ref(
				'client_appointments/' +
					PROJECT_CODE.projectCode +
					'/' +
					location.state.clientAppCode +
					'/users'
			);

		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum ? elevationPriceSum : '';
		const elevationTabData = elevationTab ? elevationTab : '';
		const exteriorImageData = exteriorImage ? exteriorImage : '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : '';
		const totalUpgradePriceData = totalUpgradePrice ? totalUpgradePrice : '';
		const irrevocableDateData = irrevocableDate ? irrevocableDate : '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails ? individualDetails : '';
		const corporationDetailsData = corporationDetails ? corporationDetails : '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';

		if (elevationListData === '') {
			console.log('empty ' + lotListData);
		} else {
			console.log('not empty ');
		}

		var documentJson = {
			isCompleted: isCompletedData,
			disable: disableData,
			expanded: expandedData,
			lotList: lotListData,
			elevationList: elevationListData,
			pricingDetails: pricingDetailsData,
			displayFinal: displayFinalData,
			elevationPriceSum: elevationPriceSumData,
			buildingPriceSum: buildingPriceSumData,
			lotPriceSum: lotPriceSumData,
			exteriorImage: exteriorImageData,
			elevationPrice: elevationPriceData,
			elevationTab: elevationTabData,
			elevationId: elevationIdData,
			lotPrice: lotPriceData,
			totalUpgradePrice: totalUpgradePriceData,
			irrevocableDate: irrevocableDateData,
			closingDate: closingDateData,
			individualDetails: individualDetailsData,
			corporationDetails: corporationDetailsData,
			lawyerDetails: lawyerDetailsData,
			mortgageDetails: mortgageDetailsData,
		};

		SaveOrUpdateDocument(firebase, documentJson);
	};

	// Progress Bar
	// PROGRESS BAR -------
	var MIN = 0;

	const normaliseBuildingPrice = (value) =>
		((value - MIN) * 100) / (buildingPriceSum - MIN);

	const normaliseElevationPrice = (value) =>
		((value - MIN) * 100) / (elevationPriceSum - MIN);

	const normaliseLotPrice = (value) =>
		((value - MIN) * 100) / (lotPriceSum - MIN);

	const normaliseOption = (value) =>
		((value - MIN) * 100) / (lotPriceSum - MIN);

	const normaliseTotalPrice = (value) =>
		((value - MIN) * 100) /
		(buildingPriceSum + elevationPriceSum + lotPriceSum - MIN);

	const normaliseUpgradePrice = (value) =>
		((value - MIN) * 100) / (totalUpgradePrice - MIN);

	const BuildingNameProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#04E762',
		},
	}))(LinearProgress);

	const ElevationProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#F17105',
		},
	}))(LinearProgress);

	const LotProgress = withStyles((theme) => ({
		root: {
			height: 7,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#6665DD',
		},
	}))(LinearProgress);
	const FloorplanProgress = withStyles((theme) => ({
		root: {
			height: 7,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#6665DD',
		},
	}))(LinearProgress);

	const UpgradeProgress = withStyles((theme) => ({
		root: {
			height: 7,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#6665DD',
		},
	}))(LinearProgress);

	const TotalProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#0496FF',
		},
	}))(LinearProgress);

	const closeModalHandler = () => setShow(false);

	const handleEdit = () => setShow(false);

	return (
		<div>
			{/* Lots */}
			<Accordion square expanded={expanded === 0} onChange={handleChange(0)}>
				<AccordionSummary
					aria-controls='modelhomes-content'
					id='modelhomes-header'
					disabled={disable.lots}
				>
					{console.log('LOSTLIST: ' + JSON.stringify(lotList))}
					<Typography
						className={styles.cardTitle}
						id={isCompleted.lots === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} />
						Lots
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' disabled onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleLotsNext();
							}}
							disabled={disable.lots}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{lotList[0] === undefined || lotList[0] === '' ? (
							<div className='empty_state_handler'>
								Please choose a lot in the site plan.
							</div>
						) : (
							lotList.map((lot) => {
								return (
									<div
										className={`${
											active === lot.name
												? `lot_single_card building_active`
												: `lot_single_card`
										} ${lot.soldout === true ? `card_disabled` : ``}`}
										key={lot.name}
										data-lotname={lot.name}
										data-lotnumber={lot.buildingLot}
										onClick={(e) => elevationHandler(e)}
									>
										<p className='lot_single_title'>Lot {lot.buildingLot}</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon
													className={`${
														lot.soldout === true ? `soldout` : `available`
													}`}
												/>
											</span>
											{lot.sqft} SQ FT {'  '}/ {'  '}${lot.buildingPrice}
										</small>
										{lot.soldout === true ? null : (
											<CheckIcon
												className={`${
													active === lot.name
														? `checkmark checkmark_active`
														: `checkmark`
												}`}
											/>
										)}
									</div>
								);
							})
						)}
						{lotList[0] && (
							<div className='lot_modelhomes_manual'>
								<div className='lot_available'>
									<p>
										<span>
											<RadioButtonUncheckedIcon />
										</span>
										AVAILABLE
									</p>
								</div>
								<div className='lot_sold_out'>
									<p>
										<span>
											<RadioButtonUncheckedIcon />
										</span>
										SOLD OUT
									</p>
								</div>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					displayFinal.lots === true && expanded !== 0
						? 'final_display d-block'
						: 'd-none'
				}
			>
				{console.log('ELEVATION LIST: ' + JSON.stringify(lotList[0]))}
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>Lot {lotList[0]?.buildingLot}</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							{lotList[0]?.sqft + ' SQFT'}
							{'  '}/ {'  '}$ {pricingDetails[0]?.buildingPrice}
						</small>
						<CheckIcon className='checkmark checkmark_active' />
					</div>
				</div>
			</div>

			{/* Model Homes */}
			<Accordion square expanded={expanded === 1} onChange={handleChange(1)}>
				<AccordionSummary
					aria-controls='modelhomes-content'
					id='modelhomes-header'
					disabled={disable.modelhomes}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.modelhomes === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} />
						Model Homes
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleModelHomesNext();
							}}
							disabled={disable.modelhomes}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{elevationId === undefined || elevationId === '' ? (
							<div className='empty_state_handler'>
								Please choose an elevation.
							</div>
						) : (
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{lotList[0].name} {elevationId && elevationId}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									Elevation{' '}
									{elevationId !== undefined || elevationId !== ''
										? 'Added'
										: elevationId}{' '}
								</small>

								<CheckIcon className='checkmark checkmark_active' />
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			{console.log('displayfinal modelhomes: ' + displayFinal.modelhomes)}
			<div
				className={
					displayFinal.modelhomes === true && expanded !== 1
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>
							{lotList[0]?.name} {elevationId && elevationId}
						</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							Elevation{' '}
							{elevationId !== undefined || elevationId !== ''
								? 'Added'
								: elevationId}{' '}
							{'  '}/ {'  '}
							Floorplan {floorplan}
						</small>

						<CheckIcon className='checkmark checkmark_active' />
					</div>
				</div>
			</div>

			{/* Pricing */}
			<Accordion square expanded={expanded === 2} onChange={handleChange(2)}>
				<AccordionSummary
					aria-controls='pricing-content'
					id='pricing-header'
					disabled={disable.pricing}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.pricing === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} /> Pricing
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handlePricingNext();
							}}
						>
							Next
						</button>
					</div>
					<div className='stepbar_pricing_container'>
						{/* <div className='buildingname_progress'>
							<div className={styles.progressBar}>
								<BuildingNameProgress
									variant='determinate'
									value={normaliseBuildingPrice(
										elevationList[0]?.buildingPrice
									)}
								/>

								<div className='price_label'>
									<div className='price_amount'>
										${elevationList[0]?.buildingPrice}
									</div>
									<div className='price_legend'>
										{elevationList[0]?.buildingName}
									</div>
								</div>
							</div>
						</div> */}
						<div className='elevation_progress'>
							<div className={styles.progressBar}>
								<ElevationProgress
									variant='determinate'
									value={normaliseElevationPrice(elevationPrice)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										${numberWithCommas(elevationPrice.toFixed(2))}
									</div>
									<div className='price_legend'>
										Elevation{' '}
										{elevationId === undefined || elevationId === ''
											? 'A'
											: elevationId}
									</div>
								</div>
							</div>
						</div>
						<div className='lot_progress'>
							<div className={styles.progressBar}>
								<LotProgress
									variant='determinate'
									value={normaliseLotPrice(lotPrice)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										${numberWithCommas(lotPrice.toFixed(2))}
									</div>
									<div className='price_legend'>
										Lot {pricingDetails[0]?.id}
									</div>
								</div>
							</div>
						</div>
						{/* <div className='upgrades_progress'>
							<div className={styles.progressBar}>
								<LotProgress
									variant='determinate'
									value={normaliseUpgradePrice(upgradeTotal)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										${totalUpgrades.toFixed(2)}
									</div>
									<div className='price_legend'>Upgrades</div>
								</div>
							</div>
						</div> */}
						<div className='total_progress'>
							<div className={styles.progressBar}>
								<TotalProgress
									variant='determinate'
									value={normaliseTotalPrice(
										elevationPrice + lotPrice + totalUpgrades
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{numberWithCommas(
											(elevationPrice + lotPrice + totalUpgrades).toFixed(2)
										)}
									</div>
									<div className='price_legend'>Total</div>
								</div>
							</div>
						</div>
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.pricing === true && expanded !== 2
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					<div className={styles.progressBar}>
						<TotalProgress
							variant='determinate'
							value={normaliseTotalPrice(
								elevationPrice + lotPrice + totalUpgrades
							)}
						/>
						<div className='price_label'>
							<div className='price_amount'>
								${numberWithCommas(elevationPrice + lotPrice + totalUpgrades)}
							</div>
							<div className='price_legend'>Total</div>
						</div>
					</div>
				</div>
			</div>

			{/* Client */}
			<Accordion square expanded={expanded === 3} onChange={handleChange(3)}>
				<AccordionSummary
					aria-controls='client-content'
					id='client-header'
					disabled={disable.client}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.client === true ? 'isCompleted' : null}
					>
						{' '}
						<StopRoundedIcon className={styles.caret} />
						Client
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleClientNext();
							}}
							disabled={disable.client}
						>
							Next
						</button>
					</div>

					{individualDetails ? (
						<div className='lot_modelhomes_container'>
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{individualDetails?.firstName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{individualDetails?.address}
								</small>
								<br />
								{console.log(JSON.stringify(corporationDetails))}
								<small className='small_number'>
									{individualDetails?.phoneNumber}
								</small>
							</div>
						</div>
					) : (
						corporationDetails && (
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{corporationDetails?.corporationName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{corporationDetails?.businessAddress}
									</small>
									<br />
									{console.log(JSON.stringify(corporationDetails))}
									<small className='small_number'>
										{corporationDetails?.businessPhone}
									</small>
								</div>
							</div>
						)
					)}
					<button
						className='sign_doc'
						onClick={() => {
							setShow(true);
						}}
						disabled={disable.client}
					>
						Pay Deposit
					</button>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.client === true && expanded !== 3
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					{individualDetails ? (
						<div className='lot_modelhomes_container'>
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{individualDetails?.firstName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{individualDetails?.address}
								</small>
								<br />
								{console.log(JSON.stringify(corporationDetails))}
								<small className='small_number'>
									{individualDetails?.phoneNumber}
								</small>
								<CheckIcon className='checkmark checkmark_active' />
							</div>
						</div>
					) : (
						corporationDetails && (
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{corporationDetails?.corporationName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{corporationDetails?.businessAddress}
									</small>
									<br />
									{console.log(JSON.stringify(corporationDetails))}
									<small className='small_number'>
										{corporationDetails?.businessPhone}
									</small>
									<CheckIcon className='checkmark checkmark_active' />
								</div>
							</div>
						)
					)}
				</div>
			</div>

			{show ? (
				<div onClick={closeModalHandler} className='back-drop'></div>
			) : null}
			<Modal
				show={show}
				close={closeModalHandler}
				title='Review Your Document'
				buttonName='Pay Now'
				button={handleDocument}
			>
				{/* Model Homes, Pricing, Dates, Client, Lawyer, Finances */}

				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>Lot {lotList[0]?.buildingLot}</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							{lotList[0]?.sqft + ' SQFT'}
							{'  '}/ {'  '}$ {pricingDetails[0]?.buildingPrice}
						</small>
						<div className='edit_btn'>
							<a
								onClick={() => {
									handleEdit();
									setExpanded(0);
									navigation.go(0);
								}}
							>
								Edit
							</a>
						</div>
					</div>
				</div>
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>{elevationList[0]?.buildingName}</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							Elevation{' '}
							{elevationId === undefined || elevationId === ''
								? 'A'
								: elevationId}{' '}
							{'  '}/ {'  '}
							Lot {pricingDetails[0]?.id}
						</small>
						<div className='edit_btn'>
							<a
								onClick={() => {
									handleEdit();
									setExpanded(1);
									navigation.go(1);
								}}
							>
								Edit
							</a>
						</div>
					</div>
				</div>
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>Total Cost</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							${numberWithCommas(+elevationPrice + +lotPrice + +totalUpgrades)}
						</small>
						<div className='edit_btn'>
							<a
								onClick={() => {
									handleEdit();
									setExpanded(2);
									navigation.go(2);
								}}
							>
								Edit
							</a>
						</div>
					</div>
				</div>
				<div className='total_progress_final_display'>
					{individualDetails ? (
						<div className='lot_modelhomes_container'>
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{individualDetails?.firstName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{individualDetails?.address}
								</small>
								<br />
								{console.log(JSON.stringify(corporationDetails))}
								<small className='small_number'>
									{individualDetails?.phoneNumber}
								</small>
								<div className='edit_btn'>
									<a
										onClick={() => {
											handleEdit();
											setExpanded(3);
											navigation.go(3);
										}}
									>
										Edit
									</a>
								</div>
							</div>
						</div>
					) : (
						corporationDetails && (
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{corporationDetails?.corporationName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{corporationDetails?.businessAddress}
									</small>
									<br />
									{console.log(JSON.stringify(corporationDetails))}
									<small className='small_number'>
										{corporationDetails?.businessPhone}
									</small>
									<div className='edit_btn'>
										<a
											onClick={() => {
												handleEdit();
												setExpanded(3);
												navigation.go(3);
											}}
										>
											Edit
										</a>
									</div>
								</div>
							</div>
						)
					)}
				</div>
				<div className='lot_modelhomes_container'>
					{mortgageDetails && (
						<div className='lot_single_card'>
							<p className='lot_single_title'>
								{mortgageDetails?.institutionName}
							</p>
							<small className='lot_single_sqft'>
								<span className='lot_availability'>
									<FiberManualRecordIcon className='available' />
								</span>
								TOTAL DOWNPAYMENT
								<span className='mortgage_amount_total'>
									${mortgageDetails?.totalDownpayment}
								</span>
							</small>
							<br />
							<div className='edit_btn'>
								<a
									onClick={() => {
										handleEdit();
										setExpanded(4);
										navigation.go(4);
									}}
								>
									Edit
								</a>
							</div>
						</div>
					)}
				</div>
			</Modal>
		</div>
	);
}

export default StepBar;
